{
  "appName": "Profiling.app",
  "save": "Save",
  "cancel": "Cancel",
  "loading": "Loading…",
  "placeholder": "Here be dragons…",
  "resendVerifyEmail": "Re-send confirmation email",
  "nav": {
    "dashboard": "Dashboard",
    "assignments": "Assignments",
    "briefs": "Briefs",
    "evaluations": "Evaluations",
    "billing": "Billing",
    "myProfiles": "My Profiles",
    "admin": "Admin",
    "settings": "Settings",
    "account": "Account",
    "logout": "Logout",
    "newWorkspace": "New Workspace"
  },
  "pagination": {
    "previous": "Previous page",
    "next": "Next page",
    "pageOf": "Page {{page}} of {{pages}}"
  }
}
